import Vue from "vue";
import Clickoutside from 'element-ui/lib/utils/clickoutside';

// Directive
Vue.directive('focus', {
    inserted: function (el, binding) {
        if (binding.value && el.nodeName == 'INPUT') {
            el.focus(); //普通input标签
        }
        if (binding.value && el.nodeName != 'INPUT') {
            el.getElementsByTagName('input')[0].focus(); //e-input 标签
        }
    }
});
Vue.directive('tesxAreaFocus', {
    inserted: function (el, binding) {
        if (binding.value && el.nodeName == 'TEXTAREA') {
            el.focus(); //普通TEXTAREA标签
        }
    }
});

// Clickoutside for popup layer closure
Vue.directive('clickoutside', Clickoutside);

// Autoheight
Vue.directive('autoheight', {
    update: function (el, binding, vnode) {
        const vm = vnode.context;
        let maxHeight = 0;
        let body = window.document.body;
        if (window.innerHeight) {
            maxHeight = window.innerHeight;
        } else if (body.parentElement.clientHeight) {
            maxHeight = body.parentElement.clientHeight;
        } else if (body && body.clientHeight) {
            maxHeight = body.clientHeight;
        }
        // Tab header height
        let tabHeight = 40;
        maxHeight = maxHeight - tabHeight;

        let isTable = (el.className.indexOf('el-table') != -1);
        let isRightArea = (el.className.indexOf('common-right-area') != -1);
        let isRightAreaTab = (el.className.indexOf('el-tabs') != -1);
        let fixedHeight = binding.value;

        // Fix the height of right area
        if (isRightArea) {
            el.style.height = maxHeight + 'px';
            return;
        }
        if (isNaN(fixedHeight)) {
            fixedHeight = 50;
            if (isTable) {
                fixedHeight = 106;
            }
            if (isRightAreaTab) {
                fixedHeight = 80;
            }
        }

        let bottomMarginHeight = 10;
        let height = maxHeight - fixedHeight - bottomMarginHeight;

        // Check if el-table component, need to set body wraper height
        if (isTable) {
            el.childNodes.forEach(item => {
                let className = item.className;
                if (className && className.indexOf('el-table__body-wrapper') != -1) {
                    item.style.height = height + 'px';
                }
            });
        } else if (isRightAreaTab) {
            el.childNodes.forEach(item => {
                let className = item.className;
                if (className && className.indexOf('el-tabs__content') != -1) {
                    item.style.height = height + 'px';
                }
            })
        } else {
            // Set height
            el.style.height = height + 'px';
        }
    }
});

//numberOnly
Vue.directive('numberOnly', {
    update: function (el) {
        el.value = el.value.replace(/\D+/g, '')
    }
});


// WEBPACK FOOTER //
// ./src/plugins/directive.js